import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission, Permission } from '../utils/permissions';

interface PermissionRouteProps {
  children: React.ReactNode;
  requiredPermission: Permission | null;
  fallbackPath?: string;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ 
  children, 
  requiredPermission, 
  fallbackPath = '/dashboard' 
}) => {
  const { organization } = useAuth();

  if (!hasPermission(organization?.permissions, requiredPermission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default PermissionRoute;
